import type { FaireProductEntity } from "../../entity_types/product";

export const p_jwuj7ag6n6: FaireProductEntity = {
  token: "p_jwuj7ag6n6",
  type: "product",
  name: "Arkansas Long Sleeve – Razorbacks (HOGS)",
  brandToken: "b_qcb86t4azp",
  brandName: "Newport Knits",
  imageUrl:
    "https://cdn.faire.com/fastly/cf82db77844c26854dc6d90ef059e6d14da0d1659d3015134838f3f256612fb9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/68f4a7c53d7972fe2656077fb80f1cf9020c9cf4e6cb52dce7485ba3ca22c790.png",
  ],
  priceDollars: 65,
  description:
    "Show your Razorback spirit in this classic 100% cotton sweater. This crew neck sweater features ARKANSAS on the front with a bold HOGS on the back in the white stripe detail. Ideal for game day, calling the HOGS from your couch or any day you want to rep your Razorback pride! \n",
  tags: [],
  msrpDollars: 130,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T22:14:30.987Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
